import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCreditCardAdd"><Path d="M2.5 10V19.5H13.5M2.5 10V4.5H21.5V10M2.5 10H21.5M21.5 10V11.5M19.5 14.5V17.5M19.5 17.5V20.5M19.5 17.5H16.5M19.5 17.5H22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCreditCardAdd;
